// extracted by mini-css-extract-plugin
export default {"switchLang":"LangSwitch_switchLang__7OAA4","hiddenLang":"LangSwitch_hiddenLang__yP6IY","showLang":"LangSwitch_showLang__aq8ds"};